import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_MEM_78 } from "@/lib/programData";

export default function MarrakechLoop78Page() {
  return <ProgramTemplate program={PROGRAM_MEM_78} variant="mem" showJourneyChronology />;
}
